/** `m:ss` for a remaining duration in ms — floored, never negative. Shared by
 *  the preview banner's session countdown and the re-mint / start rate-limit
 *  texts (moved here from `RolePreviewBanner`). */
export function fmtCountdown(msLeft: number): string {
  const s = Math.max(0, Math.floor(msLeft / 1000));
  const m = Math.floor(s / 60);
  const ss = s % 60;
  return `${m}:${ss.toString().padStart(2, "0")}`;
}
